import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { SubscribeService } from '../../service/subscribe.service';
import { NgForm } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
var SubscribeComponent = /** @class */ (function () {
    function SubscribeComponent(subscribeService) {
        this.subscribeService = subscribeService;
        this.showPrivacy = new EventEmitter();
        this.temp = false;
        this.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }
    SubscribeComponent.prototype.onSubscribe = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var postModel, result, form;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isBusy = true;
                        postModel = {
                            email: email,
                            agreementText: {
                                title: this.data.agreementText.title,
                                description: this.data.agreementText.description,
                            },
                            reCaptchaToken: this.captchaResponse
                        };
                        return [4 /*yield*/, this.subscribeService.subscribe(postModel)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            form = this.form.form;
                            this.isSuccess = true;
                            this.isSubscribed = true;
                            this.agreed = this.agreedControlNoChanges || false;
                            this.email = '';
                            form.markAsUntouched();
                            form.markAsPristine();
                            form.updateValueAndValidity();
                        }
                        else {
                            this.isSuccess = false;
                        }
                        this.resetCaptcha();
                        this.isBusy = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SubscribeComponent.prototype.reCaptchaValidated = function (response) {
        this.captchaResponse = response;
    };
    SubscribeComponent.prototype.resetCaptcha = function () {
        this.captcha.reset();
        this.captchaResponse = null;
    };
    return SubscribeComponent;
}());
export { SubscribeComponent };
